import * as React from 'react';

import { EtazhiBlackFridayTopBanner } from '../EtazhiBlackFridayTopBanner';
import { usePromoOffersVisibility } from './hooks';

export const EtazhiBlackFridayPromotion: React.FC = () => {
  const isPromoOffersDataVisible = usePromoOffersVisibility();

  if (isPromoOffersDataVisible) {
    /**
     * Если есть данные по запросу объектов "Этажей" к чёрной пятнице, то будет выводиться
     * промо-полка вместо баннера.
     * @todo: компонент промо-полки.
     *
     * Если таких объектов нет - то выводим баннер.
     */
    return 'Здесь будет промо-полка';
  }

  return <EtazhiBlackFridayTopBanner />;
};
